(() => {
 'use strict';
 const product=document.querySelector('[data-ottoman-pending]');
 if(!product)return;
 const dialog=product.querySelector('#fm-ottoman-customise');
 const form=dialog.querySelector('[data-ottoman-form]');
 const groups=[...form.querySelectorAll('[data-custom-group]')];
 const fields=[...form.querySelectorAll('[data-custom-option]')];
 const familySelect=form.querySelector('[data-fabric-family]');
 const currentChoice=form.querySelector('[data-current-choice]');
 const emptyChoice=currentChoice.textContent;
 const key='fm-ottoman-v1:'+product.dataset.productHandle;
 let opener;
 let state={};
 try{const stored=JSON.parse(sessionStorage.getItem(key)||'{}');for(const field of fields){if(stored?.[field.name]===field.value){state[field.name]=field.value;field.checked=true;}}}catch{}
 const filterFamilies=()=>form.querySelectorAll('[data-fabric-group]').forEach(group=>{group.hidden=familySelect.value!=='all'&&group.dataset.fabricGroup!==familySelect.value;});
 const refresh=()=>{
  for(const group of groups){
   const name=group.dataset.customGroup;
   const radio=group.querySelector('input:checked');
   if(!radio)continue;
   state[name]=radio.value;
   product.querySelector('[data-custom-summary="'+name+'"]').textContent=radio.value;
   const chip=radio.closest('label').querySelector('i');
   if(chip){const icon=product.querySelector('[data-custom-icon="colour"]');icon.replaceChildren(chip.cloneNode());icon.classList.add('has-colour');}
  }
  const selections=groups.map(g=>state[g.dataset.customGroup]).filter(Boolean);
  if(selections.length)product.querySelectorAll('[data-ottoman-summary]').forEach(n=>n.textContent=selections.join(' · '));
  const active=groups.find(g=>!g.hidden);
  currentChoice.textContent=state[active?.dataset.customGroup]||emptyChoice;
 };
 fields.forEach(field=>field.addEventListener('change',()=>{refresh();try{sessionStorage.setItem(key,JSON.stringify(state));}catch{}}));
 familySelect.addEventListener('change',filterFamilies);
 form.addEventListener('submit',event=>event.preventDefault());
 product.querySelectorAll('[data-ottoman-open]').forEach(button=>button.addEventListener('click',()=>{
  opener=button;
  const name=button.dataset.ottomanOpen;
  groups.forEach(g=>g.hidden=g.dataset.customGroup!==name);
  const group=groups.find(g=>!g.hidden);
  dialog.querySelector('h2').textContent=group.querySelector('legend').textContent;
  dialog.dataset.activeGroup=name;
  if(name==='colour'){
   const selected=group.querySelector('input:checked');
   familySelect.value=selected?.closest('[data-fabric-group]').dataset.fabricGroup||'all';
   filterFamilies();
  }
  document.querySelectorAll('dialog[open]').forEach(d=>d.close());
  if(dialog.classList.contains('fm-mobile-option-panel'))dialog.show();else dialog.showModal();
  refresh();
  (group.querySelector('input:checked')||group.querySelector('input'))?.focus({preventScroll:true});
  dialog.scrollTop=0;
 }));
 dialog.addEventListener('close',()=>opener?.focus({preventScroll:true}));
 refresh();
})();
